import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=05020225&scoped=true"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAddress.vue?vue&type=style&index=0&id=05020225&prod&lang=sass&scoped=true"
import style1 from "./DeliveryAddress.vue?vue&type=style&index=1&id=05020225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05020225",
  null
  
)

export default component.exports